// extracted by css-extract-rspack-plugin
export default {"spaceXXSmall":"4px","trend":"byod-kpi-trend-indicator__trend___QYeEi"};